import axios from 'axios';
import {
  CLEAR_YOUTUBE_STATE,
  SEARCH_YOUTUBE_VIDEOS,
  INIT_YOUTUBE_VIDEOS,
  SEARCH_MORE_YOUTUBE_VIDEOS,
  APPEND_YOUTUBE_VIDEOS,
  SET_YOUTUBE_SEARCH_QUERY,
  OPEN_YOUTUBE_SORT_LAYER,
  CLOSE_YOUTUBE_SORT_LAYER,
  SET_YOUTUBE_SORT_OPTION
} from './action-types';

export const clearYoutubeState = () => ({
  type: CLEAR_YOUTUBE_STATE,
});

const searchYoutubeVideos = () => ({
  type: SEARCH_YOUTUBE_VIDEOS,
});

const initYoutubeVideos = ({ videos, nextPageToken }) => ({
  type: INIT_YOUTUBE_VIDEOS,
  videos,
  nextPageToken,
});

const searchMoreYoutubeVideos = () => ({
  type: SEARCH_MORE_YOUTUBE_VIDEOS,
});

const appendYoutubeVideos = ({ videos, nextPageToken }) => ({
  type: APPEND_YOUTUBE_VIDEOS,
  videos,
  nextPageToken,
});

export const setYoutubeSearchQuery = searchQuery => ({
  type: SET_YOUTUBE_SEARCH_QUERY,
  searchQuery,
});

export const openYoutubeSortLayer = () => ({
  type: OPEN_YOUTUBE_SORT_LAYER,
});

export const closeYoutubeSortLayer = () => ({
  type: CLOSE_YOUTUBE_SORT_LAYER,
});

export const setYoutubeSortOption = sortOption => ({
  type: SET_YOUTUBE_SORT_OPTION,
  sortOption,
});

export const fetchYoutubeVideos = () => async (dispatch, getState) => {
  const {
    searchQuery, sortOption, isFetching,
  } = getState().plugins.YoutubeSearch;

  if (isFetching) {
    return;
  }

  dispatch(searchYoutubeVideos());

  const url = `/plugin/YouTubeApi?editor=8&query=${searchQuery}&option=${sortOption}&maxResults=12`;
  const res = await axios.get(url);
  const { items, nextPageToken } = res.data.data;

  const videos = !items
    ? []
    : items.map(({ id, snippet }) => ({
      id: id.videoId,
      title: snippet.title,
      imageUrl: snippet.thumbnails.medium.url,
    }));

  dispatch(initYoutubeVideos({ videos, nextPageToken }));
};

export const fetchMoreYoutubeVideos = () => async (dispatch, getState) => {
  const {
    searchQuery, sortOption,
    nextPageToken, isFetchingMore,
  } = getState().plugins.YoutubeSearch;

  if (!nextPageToken || isFetchingMore) {
    return;
  }

  dispatch(searchMoreYoutubeVideos());

  const url = `/plugin/YouTubeApi?editor=8&query=${searchQuery}&option=${sortOption}&page=${nextPageToken}&maxResults=8`;
  const res = await axios.get(url);
  const { data } = res.data;

  const videos = data.items.map(({ id, snippet }) => ({
    id: id.videoId,
    title: snippet.title,
    imageUrl: snippet.thumbnails.medium.url,
  }));

  dispatch(appendYoutubeVideos({ videos, nextPageToken: data.nextPageToken }));
};
